export default {
  title: "Me contacter",
  bottom: "Fait avec React.js & Gatsby.js avec ❤️ et ☕ par Alexandre Le Lain.",
  mail: "lelain.alexandre@gmail.com",
  twitter: "@a_lelain",
  github: "alexandre-lelain",
  linkedin: "alexandre-lelain",
}
